import { defineStore } from 'pinia'
import { reactive, computed, watch } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const context: ToastContext = reactive({
    items: [],
  })

  /**
   * トーストアイテムの初期化が完了しているかどうか
   * @description items 配列のすべてのアイテムに id と message が定義されている
   */
  const isInitialized = computed<boolean>(() => {
    return context.items.every(v => !!v.id && !!v.message)
  })

  watch(() => context.items.length, (newValue, oldValue) => {
    if (newValue > oldValue) {
      initToastItem()
    }
  })

  const initToastItem = () => {
    const DEFAULT_DURATION = 8.2
    context.items = context.items.filter(v => v.message).map(v => {
      return {
        id: v.id || `toast-${new Date().getTime()}`,
        messageType: v.messageType || 'notice',
        message: v.message || '',
        duration: v.duration || DEFAULT_DURATION,
      }
    })
  }

  const setToastItem = (item: ToastItem) => {
    context.items.push(item)
  }

  const removeToastItem = (id: string) => {
    const index = context.items.findIndex(v => v.id === id)

    if (index !== -1) {
      context.items.splice(index, 1)
    }
  }

  /**
   * トーストクリア処理
   */
  const clearToast = async () => {
    context.items = []
  }

  return {
    // data
    context,

    // computed
    isInitialized,

    // methods
    setToastItem,
    removeToastItem,
    clearToast,
  }
})
